import React from 'react';
import { useNavigate } from 'react-router-dom';
import { XCircle, ArrowLeft, Home } from 'lucide-react';

const PaymentCancel = () => {
  const navigate = useNavigate();

  const handleRetryPayment = () => {
    navigate('/dashboard?tab=billing');
  };

  const handleGoToDashboard = () => {
    navigate('/dashboard');
  };

  const handleGoHome = () => {
    navigate('/');
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 flex items-center justify-center p-4">
      <div className="bg-[#1f2937] rounded-xl border border-gray-700/50 p-8 max-w-md w-full text-center">
        <div className="w-16 h-16 bg-orange-500/10 rounded-full flex items-center justify-center mx-auto mb-4">
          <XCircle className="w-8 h-8 text-orange-500" />
        </div>
        
        <h1 className="text-2xl font-bold text-white mb-2">Payment Cancelled</h1>
        <p className="text-gray-300 mb-6">
          Your payment was not completed. You can try again or return to your dashboard.
        </p>

        <div className="space-y-3">
          <button
            onClick={handleRetryPayment}
            className="w-full bg-[#a15507] hover:bg-[#924e06] text-white py-3 px-6 rounded-lg font-medium transition-colors flex items-center justify-center gap-2"
          >
            <ArrowLeft className="w-4 h-4" />
            Try Again
          </button>
          
          <button
            onClick={handleGoToDashboard}
            className="w-full bg-[#374151] hover:bg-[#4B5563] text-white py-3 px-6 rounded-lg font-medium transition-colors"
          >
            Go to Dashboard
          </button>
          
          <button
            onClick={handleGoHome}
            className="w-full bg-[#374151] hover:bg-[#4B5563] text-white py-3 px-6 rounded-lg font-medium transition-colors flex items-center justify-center gap-2"
          >
            <Home className="w-4 h-4" />
            Go Home
          </button>
        </div>

        <div className="mt-6 pt-6 border-t border-gray-700/50">
          <p className="text-gray-400 text-sm">
            Need help? Contact our support team.
          </p>
        </div>
      </div>
    </div>
  );
};

export default PaymentCancel;
